import { createContext as t } from "react";
const o = t({
  variant: "primary"
});
export {
  o as default
};
